<img src="../../../assets/icons/loading.gif" alt="">